import React from "react";
import "./HundredCreator.css";
import LazyImage from "../../../components/LazyImage/LazyImage";
import { DEFAULT_USER_AVATAR } from "../../../shared/constants/common";

const HundredCreator = ({
  lists,
  totalCreators
}) => {
  // Only show when totalCreators is 100 or more
  if (totalCreators < lists.length) {
    return null;
  }

  // Calculate the milestone count (100, 125, 150, 175, etc.)
  // This increments every 25 creators after 100
  // If totalCreators is less than 100, show 100
  const milestoneCount = totalCreators < 100 
    ? 100 
    : 100 + Math.floor((totalCreators - 100) / 25) * 25;

  // Calculate which profile pictures to show based on the milestone
  // Rotate through the available creators for dynamic PFP updates
  const getDisplayedAvatars = () => {
    if (!lists || lists.length === 0) {
      return [];
    }

    // Determine rotation index based on milestone
    // Every 25 creators, we shift which avatars are shown
    const rotationIndex = Math.floor((totalCreators - 100) / 25);
    const rotatedLists = [];

    // Cycle through the lists array based on rotationIndex
    for (let i = 0; i < lists.length; i++) {
      const sourceIndex = (rotationIndex + i) % lists.length;
      rotatedLists.push(lists[sourceIndex]);
    }

    // If we need more avatars than available, fill with default or repeat
    while (rotatedLists.length < lists.length && lists.length > 0) {
      const fillIndex = (rotationIndex + rotatedLists.length) % lists.length;
      rotatedLists.push(lists[fillIndex]);
    }

    return rotatedLists;
  };

  const displayedAvatars = getDisplayedAvatars();

  return (
    <div className="connect-creators-cta">
      <div className="connect-creators-card">
        <div className="connect-creators-border"></div>
        <div className="connect-creators-bg"></div>
        <div className="connect-creators-content">
          <div className="connect-creators-text">
            <h3 className="connect-creators-title">
              Connect with your favorite creators today
            </h3>
            <div className="connect-creators-avatars">
              <div className="avatars-group">
                {displayedAvatars.map((list, index) => (
                  <div className="avatar-item" key={`${totalCreators}-${index}`}>
                    <LazyImage
                      src={list?.profile_picture || DEFAULT_USER_AVATAR}
                      alt="Creator"
                      width={40}
                      height={40}
                    />
                  </div>
                ))}
              </div>
              <span className="connect-creators-count">
                + {milestoneCount.toLocaleString()} creators recently joined
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HundredCreator;

